(function (window) {

    var sitefooter = function () {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_CSS = 'open';
        var OVERLAY = 'overlay';
        var NO_SCROLL = 'noscroll';
        var MEDIA_QUERY = '(max-width: 767px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.$footerLinkToggle = $('.js-footer-links-title')
            ui.$footerlists = $('.js-footer-link-list');
        }

        function toggleFooterLinkCol(e) {
            if(mql.matches) {
                e.preventDefault();
                $(e.target).prop("disabled", true);
                $(e.target).toggleClass('active');
                $(e.target).next().slideToggle('slow', function(){
                    $(e.target).prop("disabled", false);
                });
            }
        }

        function handleMediaQueryChange(mql) {
            isMobile = mql.matches ? true : false;
            if (!isMobile) {
                ui.$footerlists.removeAttr("style");
                ui.$footerLinkToggle.removeClass('active');
            }
        }

        function bindEvents() {
            ui.$footerLinkToggle.on('click', toggleFooterLinkCol);
            mql.addEventListener("change", () => {
                handleMediaQueryChange(mql);
            });
        }

        function init() {
            cacheUI();
            bindEvents();
            handleMediaQueryChange(mql);
        }

        return {
            init: init
        };
    };

    var footer = sitefooter();
    footer.init();
})(window);
